export default "<button title=\"{{'BUTTONS.view' | translate}}\" class=\"{{class}}\" (click)=\"view()\">{{'BUTTONS.view' | translate}}</button>\r\n";